import { failMe } from '@moojo/misc-constructs'

import { extensionMarkup } from './extension-markup'

export const AdExtension = {
  name: 'AdContainer',
  type: 'response',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  match: ({ trace }: { trace: any }) => trace.type === 'convo_ad' || trace.payload?.name === 'convo_ad',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  render: async ({ trace, element }: { trace: any; element: Element }) => {
    const { apiBase, servingPath } = trace.payload.data
    const res = await fetch(apiBase + servingPath)
    if (res.status !== 200) {
      element.innerHTML = extensionMarkup.error
      return
    }

    const html = await res.text()

    const dom = new DOMParser().parseFromString(html, 'text/html')
    const style = dom.head.querySelector('style') ?? failMe('expected DOM node (style) not found')
    const content = dom.body.firstElementChild ?? failMe('expected DOM node (content) not found')

    // adjust cta url, point it to api base, as the server returns domain relative url.
    // TODO(roman): reconsider this.

    const cta = content.getElementsByClassName('cta-button')[0] ?? failMe('expected DOM node (cta) not found')
    const href = cta.getAttribute('href')
    if (href) {
      // important: in preview mode - href is not set
      cta.setAttribute('href', apiBase + href)
    }

    const adContainer = document.createElement('div')
    adContainer.classList.add('ad-container')
    adContainer.appendChild(style)
    adContainer.appendChild(content)

    element.appendChild(adContainer)
  },
}
